import { ServiceHelper } from "../../Everou/_services/ServiceHelper";
import { PMS_API_URLS } from "../_constants/PMS_API_URLS";

export const PMSCustomizationService = {
    get,
    update,
    uploadLogo,
    uploadBackground,
    deleteLogo,
    deleteBackground,
};

// Without organizationUid the endpoints operate on the requesting user's
// template; with it, on the organization's shared template (members only).
function organizationParams(organizationUid) {
    return organizationUid ? { organization_uid: organizationUid } : undefined;
}

function withOrganizationParam(url, organizationUid) {
    if (!organizationUid) return url;
    return `${url}?organization_uid=${encodeURIComponent(organizationUid)}`;
}

async function get(organizationUid) {
    return await ServiceHelper.getRequest(
        PMS_API_URLS.CUSTOMIZATION_TEMPLATE,
        organizationParams(organizationUid),
    );
}

async function update(accentColor, headerColor, organizationUid) {
    return await ServiceHelper.postRequest(
        PMS_API_URLS.CUSTOMIZATION_TEMPLATE,
        {
            accent_color: accentColor,
            header_color: headerColor,
            ...(organizationUid ? { organization_uid: organizationUid } : {}),
        },
    );
}

async function uploadLogo(image, organizationUid) {
    await ServiceHelper.putImageRequest(
        withOrganizationParam(
            PMS_API_URLS.CUSTOMIZATION_UPLOAD_LOGO,
            organizationUid,
        ),
        image,
    );
}

async function uploadBackground(image, organizationUid) {
    await ServiceHelper.putImageRequest(
        withOrganizationParam(
            PMS_API_URLS.CUSTOMIZATION_UPLOAD_BACKGROUND,
            organizationUid,
        ),
        image,
    );
}

async function deleteLogo(organizationUid) {
    await ServiceHelper.deleteRequest(
        PMS_API_URLS.CUSTOMIZATION_UPLOAD_LOGO,
        organizationParams(organizationUid),
    );
}

async function deleteBackground(organizationUid) {
    await ServiceHelper.deleteRequest(
        PMS_API_URLS.CUSTOMIZATION_UPLOAD_BACKGROUND,
        organizationParams(organizationUid),
    );
}
